import axios from 'axios';
axios.defaults.baseURL = 'http://localhost/churchdockapi/api';
const appdata = {
    state: {		
        sex : null,
        maritalStatus:null				
	},	
	mutations: {		
		sex_success(state, payload){
			state.sex = payload			
        },
        maritalStatus_success(state, payload){
			state.maritalStatus = payload			
		}		
	},
	actions: {			
		getsex({commit}){
			return new Promise((resolve, reject) => {				
				axios.get('/Appdata/GetSex')
				.then(resp => resp.data)
				.then(respdata => {	
                    commit('sex_success',respdata);				
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
        getmaritalstatus({commit}){
			return new Promise((resolve, reject) => {				
				axios.get('/Appdata/GetMaritalStatus')
				.then(resp => resp.data)
				.then(respdata => {					
					commit('maritalStatus_success',respdata);					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}  
	}
}

export default appdata